import { render, staticRenderFns } from "./SITDispatch.vue?vue&type=template&id=711f564d&scoped=true&"
import script from "./SITDispatch.vue?vue&type=script&lang=js&"
export * from "./SITDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711f564d",
  null
  
)

export default component.exports